export default "__VITE_ASSET__C5rWs68b__"